module.exports = __webpack_public_path__ + "b5c0814c2cdcd92c8f85c90d4c84a7a7.svg";